import PersonalInformationPage from './PersonalInformation.page';

export default PersonalInformationPage;
